import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DriverAssignment {
  employeeOrderId: number;
  vehicleId: number | null;
  passengerEmployeeOrderIds: number[];
  passengerUserIds: number[];
}

interface OrderEntry {
  employeeOrderIdMap: Record<number, number>;
  driverAssignments: Record<number, DriverAssignment>;
}

interface OrderVehicleAssignmentState {
  orders: Record<string, OrderEntry>;
}

const initialState: OrderVehicleAssignmentState = {
  orders: {},
};

const ensureOrder = (state: OrderVehicleAssignmentState, orderNumber: string) => {
  if (!state.orders[orderNumber]) {
    state.orders[orderNumber] = { employeeOrderIdMap: {}, driverAssignments: {} };
  }
};

const orderVehicleAssignmentSlice = createSlice({
  name: "orderVehicleAssignment",
  initialState,
  reducers: {
    setEmployeeOrderId(
      state,
      action: PayloadAction<{ orderNumber: string; userId: number; employeeOrderId: number }>
    ) {
      const { orderNumber, userId, employeeOrderId } = action.payload;
      ensureOrder(state, orderNumber);
      state.orders[orderNumber].employeeOrderIdMap[userId] = employeeOrderId;
    },

    setDriverAssignment(
      state,
      action: PayloadAction<{ orderNumber: string; assignment: DriverAssignment }>
    ) {
      const { orderNumber, assignment } = action.payload;
      ensureOrder(state, orderNumber);
      state.orders[orderNumber].driverAssignments[assignment.employeeOrderId] = assignment;
    },

    clearOrderAssignments(state, action: PayloadAction<string>) {
      delete state.orders[action.payload];
    },
  },
});

export const { setEmployeeOrderId, setDriverAssignment, clearOrderAssignments } =
  orderVehicleAssignmentSlice.actions;

export default orderVehicleAssignmentSlice.reducer;
